<template>
    <div class="nutrition-legend-container">
        <div v-for="(range, nutrientKey) in nutrientRange" 
            class="nutrition-legend"
            :key="nutrientKey"
            v-if="range.min !== Number.MAX_SAFE_INTEGER">
            <span :style="{backgroundColor: graphInfo[nutrientKey].color}" class="legend-color"></span>
            <span class="legend-name">
                {{ graphInfo[nutrientKey].name }}
                <span class="legend-range">
                    {{ range.min }} - {{ range.max }} {{ graphInfo[nutrientKey].unit }}&nbsp;
                    (avg. {{ Math.round(range.total / range.totalNum) }} {{ graphInfo[nutrientKey].unit }})
                </span>
            </span>
        </div>
    </div>
</template>

<script>
import { MACRONUTRIENTS } from '../../card/lifestyle/food'

export default {
    name: 'nutrition-legend',
    props: {
        data: {
            type: Array
        },
        graphInfo: {
            type: Object
        }
    },

    computed: {
        /**
         * Calculates range of macronutrients (max and min values) from the data
         */
        nutrientRange() {
            //Sets default range for MACRONUTRIENTS
            let defaultRange = MACRONUTRIENTS.reduce((accum, curr) => {
                accum[curr] = {
                    max: 0,
                    min: Number.MAX_SAFE_INTEGER,
                    total: 0,
                    totalNum: 0
                }
                return accum
                }, {})
            try {
                return this.data.reduce((rangeAccum, nutrientObj) => {
                    Object.keys(nutrientObj).forEach(nutrientKey => {
                        //Checks to see if range has a key for this macronutreint and fill max and mins
                        if(rangeAccum.hasOwnProperty(nutrientKey)) {
                            const nutrientValue = Math.round(nutrientObj[nutrientKey])
                            rangeAccum[nutrientKey].max = Math.max(rangeAccum[nutrientKey].max, nutrientValue)
                            rangeAccum[nutrientKey].min = Math.min(rangeAccum[nutrientKey].min, nutrientValue)
                            rangeAccum[nutrientKey].totalNum += 1
                            rangeAccum[nutrientKey].total += nutrientValue
                        }
                    })
                    return rangeAccum
                }, defaultRange)
            } catch (error) {
                console.error(error)
                return defaultRange
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.nutrition-legend-container {
    margin-top: 60px;
    display: flex;
    flex-wrap: wrap;
    margin-left: 50px;
    .nutrition-legend {
        width: 100%;
        display: flex;
        margin-top: 25px; 
        .legend-color {
            display: inline-block;
            width: 14px;
            height: 35px;
        }
        .legend-name {
            display: inline-block;
            flex-wrap: wrap;
            padding-left: 10px;
            font-size: 16px;
            font-weight: 700;
            .legend-range {
                font-size: 14px;
                font-weight: 400;
                display: block;
                margin-top: 4px;
            }
        }
    }
}
</style>